import React, { useState } from 'react';

import { useTheme } from 'styled-components';

import { IoMdArrowDropup, IoMdArrowDropdown } from 'react-icons/io';
import { FaSlidersH } from 'react-icons/fa';

import { Container, Content, Title, Footer, Control } from './styles';

import { ExpansiveProps } from './inteface';

const Expansive: React.FC<ExpansiveProps> = ({
  openLabel,
  closeLabel,
  children,
  title,
  initialVisible,
}) => {
  const { colors } = useTheme();

  const [visible, setVisible] = useState(
    initialVisible ? initialVisible : false,
  );

  const toggleCollapse = () => {
    setVisible(!visible);
  };

  const closeCollapse = () => {
    setVisible(false);
  };

  return (
    <Container>
      {visible ? (
        <Title>
          <div>
            <h1>
              <FaSlidersH size={26} color="#333" />
              <span>{title}</span>
            </h1>
            <button type="button" onClick={closeCollapse}>
              <IoMdArrowDropup size={32} color="#fff" />
            </button>
          </div>
        </Title>
      ) : null}

      {visible ? (
        <Content>
          <>{children}</>
        </Content>
      ) : null}

      <Footer>
        <Control onClick={toggleCollapse}>
          {visible ? (
            <>
              <IoMdArrowDropup size={32} color={colors.COLLAPSE_IC} />
              <span>{closeLabel}</span>
            </>
          ) : (
            <>
              <IoMdArrowDropdown size={32} color={colors.COLLAPSE_IC} />
              <span>{openLabel}</span>
            </>
          )}
        </Control>
      </Footer>
    </Container>
  );
};

export default Expansive;
